/**
 * L'UN add-to-cart moment: when Helio animates the cart bubble (an item was added), a few small pink hearts
 * drift out of it. Pure decoration (aria-hidden, no pointer events) and skipped for reduced motion.
 * Listening for the bubble's own animation keeps this working across header re-renders.
 */
(() => {
  const reduce = window.matchMedia?.('(prefers-reduced-motion: reduce)');
  if (!reduce || reduce.matches) return;

  let lastBurst = 0;

  /** @param {Element} bubble */
  function burst(bubble) {
    const now = Date.now();
    if (now - lastBurst < 900) return;
    lastBurst = now;

    const rect = bubble.getBoundingClientRect();
    if (!rect.width) return;

    const layer = document.createElement('div');
    layer.className = 'lun-heart-burst';
    layer.setAttribute('aria-hidden', 'true');
    layer.style.left = `${rect.left + rect.width / 2}px`;
    layer.style.top = `${rect.top + rect.height / 2}px`;

    for (let i = 0; i < 7; i += 1) {
      const heart = document.createElement('span');
      const angle = ((i - 3) * 26 + 90) * (Math.PI / 180);
      const distance = 44 + Math.random() * 38;
      heart.style.setProperty('--x', `${(Math.cos(angle) * distance * 1.1).toFixed(1)}px`);
      heart.style.setProperty('--y', `${(Math.sin(angle) * distance + 14).toFixed(1)}px`);
      heart.style.setProperty('--r', `${(i - 3) * 16}deg`);
      heart.style.setProperty('--d', `${i * 45}ms`);
      heart.style.setProperty('--s', (0.75 + Math.random() * 0.5).toFixed(2));
      layer.append(heart);
    }

    document.body.append(layer);
    window.setTimeout(() => layer.remove(), 1500);
  }

  document.addEventListener(
    'animationstart',
    (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const bubble = target.closest('.cart-bubble');
      if (bubble?.classList.contains('cart-bubble--animating')) burst(bubble);
    },
    true
  );
})();
